<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>进仓登记</h4>
    </div> -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="90px" size="mini">
        <div class="formItemBox" style="padding-top: 10px;">
          <el-form-item label="登记日期">
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="searchFrom.createTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="队列">
            <el-select v-model="searchFrom.queueId" placeholder="请选择">
              <el-option v-for="item in duilieList" :key="item.queueName" :label="item.queueName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆号牌">
            <el-input size="mini" v-model.trim="searchFrom.vehicleNo" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchFrom.jobStatArr" multiple placeholder="请选择">
              <el-option v-for="item in zhuangtaiList" :key="item.itemNo" :label="item.showName"
                  :value="item.itemNo"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务单号">
            <el-input size="mini" v-model.trim="searchFrom.no" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="发货单位">
            <el-select v-model="searchFrom.deliveryCompanyName"  placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货单位">
            <el-select v-model="searchFrom.receiveCompanyName"  placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
              :value="item.custerName"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item style="padding: 0 0 5px 10px;">
          <el-button type="primary" @click="chaxun" btnCode="01K00A0100" v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" @click="resetForm" btnCode="01K00A0200" v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" @click="createRegisterDialog = true" btnCode="01K00A0300"
            v-if="btnFlg[2]">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" @selection-change='selectGoods' style="width: 100%" height="100%" center border class="tableComent">
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column type="index" prop="date" width="280" label="操作" align="center">
          <template slot-scope="scope">
            <!-- 1显示通过/驳回 ，不是1显示记录 -->
            <div>
              <el-button  style="margin-right: 5px;" type="text" size="mini"  @click="editFn(scope.row)">修改</el-button>
              <span>
                <el-button type="text" :disabled="scope.row.jobStatus !== '4' && scope.row.jobStatus !== '10'" btnCode="01K00A0400" size="mini" v-if="btnFlg[3]" @click="shanchu(scope.row)">删除</el-button>
              </span>
              <span style="margin-left: 5px;">
                <el-button type="text" :disabled="scope.row.jobStatus == '4' || scope.row.jobStatus == '10'" btnCode="01K00A0500" size="mini" v-if="btnFlg[4]" @click="change(scope.row)">状态变更</el-button>
              </span>
              <!-- jobType  卸货 是入库 装货是出库 -->
              <span v-if="scope.row.jobStatus != '10'" style="margin-left: 5px;">
                <el-button type="text" size="mini" v-if="!scope.row.warehouseName" @click="addPlan(scope.row)">创建计划</el-button>
              </span>
              <span style="margin-left: 5px;">
                <el-button type="text" size="mini" v-if="scope.row.url" @click="lookImg(scope.row,1)">随车磅单</el-button>
              </span>
              <span style="margin-left: 5px;">
                <el-button type="text" size="mini" v-if="scope.row.unloadUrl" @click="lookImg(scope.row,2)">装卸凭证</el-button>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="deliveryCompanyName" label="发货单位" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receiveCompanyName" label="收货单位" align="center" width="200"></el-table-column>
        <el-table-column property="jobType" label="作业类型" width="100">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.jobType == '卸货'">入库卸货</span>
              <span v-if="scope.row.jobType == '装货'">出库装货</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="queueName" label="队列" width="180"></el-table-column>
        <el-table-column prop="vehicleNo" label="车牌号" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="mobilePhone" label="手机号" align="center" width="120"></el-table-column>
        <el-table-column prop="jobStatusName" label="状态" width="120">
          <template slot-scope="scope">
            <div>
              <!-- 1：排队中 2：已叫号 3：已过号 4：已失效 5：已进仓 6：进仓过磅完成 7：出仓过磅完成 8：出仓过副磅完成 9：已出仓 -->
              <span v-if="scope.row.jobStatusName == '排队中'" style="color:blue">排队中</span>
              <span v-else-if="scope.row.jobStatusName == '已叫号'" style="color:red">已叫号</span>
              <span v-else-if="scope.row.jobStatusName == '已过号'" style="color:rgb(242, 159, 25)">已过号</span>
              <span v-else>{{ scope.row.jobStatusName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="productType" label="货物类型" width="120"></el-table-column>
        <el-table-column prop="warehouseName" label="仓位" align="center" width="80"></el-table-column>
        <!-- <el-table-column prop="jobStatusName" label="作业状态"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="entryWeighing" label="进仓过磅重量(吨)" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="exitMainWeighing" label="出仓过磅重量(吨)" align="center" width="150"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="exitCompositeWeighing" label="出仓过副磅重量(吨)"
              align="center" width="150"></el-table-column> -->
        <!-- <el-table-column :show-overflow-tooltip="true" prop="poundDifference" label="磅差" align="center">
              <template slot-scope="scope">
                  <div>
                      <span
                          v-if="scope.row.poundDifference && scope.row.poundDifference !== 0 && scope.row.poundDifference !== 0.0">{{
                              scope.row.poundDifference }}%</span>
                      <span
                          v-else-if="scope.row.poundDifference == 0 || scope.row.poundDifference == 0.00">0.00%</span>
                      <span v-else></span>
                  </div>
              </template>
          </el-table-column> -->
        <!-- <el-table-column prop="jobStatusName" label="作业状态" width="100"> </el-table-column> -->
        <el-table-column width="160" prop="registrationTime" label="登记时间"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="callStationTime" label="叫号时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="mobilizationTime" label="进仓时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="entryWeighingTime" label="进仓过磅时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="exitMainTime" label="出仓过磅时间" align="center" width="160"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="exitCompositeTime" label="出仓过副磅时间" align="center"
            width="160"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="exFactoryTime" label="出仓时间" align="center" width="160"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="no" label="业务单号" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="originalTon" label="装货地净重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="grossWeight" label="装货地毛重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="tareWeight" label="装货地皮重" align="center" width="110"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadUser" label="装卸人" align="center" width="140"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="unloadTime" label="装卸时间" align="center" width="170"></el-table-column>
        <el-table-column property="registrationNo" label="登记编号" width="230"></el-table-column>
        <el-table-column prop="lineUpNo" label="排队序号" width="120"></el-table-column>
        <el-table-column prop="createUser" label="创建人" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="statusUpdateUser" label="修改人" align="center" width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="statusUpdateTime" label="修改时间" align="center" width="160"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="searchFrom.pageNo" :page-sizes="[20, 30, 40, 50]" :page-size="searchFrom.pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 新增登记 -->
    <el-dialog title="新增登记" class="register" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="createRegisterDialog" @close="createRegisterCloseDialog" @opened="createRegisterOpenedDialog" width="400px" center>
      <span>
        <el-form :rules="createRegisterFormRules" :model="createRegisterForm" ref="createRegisterForm" label-width="100px" size="mini">
          <!-- 手动输入车牌号 -->
          <el-form-item label="车牌号 :" prop="vehicleNo">
            <el-input placeholder="请输入车牌号" v-model="createRegisterForm.vehicleNo"
              v-on:input.native="createRegisterUpperVehicleNo" style="width: 190px"></el-input>
          </el-form-item>
          <!-- 模糊搜索手机号 -->
          <el-form-item label="手机号 :" prop="mobilePhone">
            <el-select v-model="createRegisterForm.mobilePhone" :multiple="false" filterable remote reserve-keyword placeholder="请输入手机号" :remote-method="createRegisterRemoteMethod"
            :loading="createRegisterLoading" loading-text="搜索中..." @change="createRegisterSelect">
              <el-option v-for="item in createRegisterMobilePhoneOptons" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="队列 :" prop="queueId">
            <el-select v-model="createRegisterForm.queueId" placeholder="请选择">
              <el-option v-for="item in duilieList" :key="item.queueName" :label="item.queueName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createRegisterDialog = false">取 消</el-button>
        <el-button @click="createRegisterSubmit" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="状态变更" class="register" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="changeMark" width="500px" @close="createDialog" center>
      <span>
        <el-form :model="changeForm" :inline="true" :rules="rules" ref="changeForm" label-width="150px" size="mini">
          <el-form-item label="状态选择:" prop="jobStatusName">
              <el-select v-model="changeForm.jobStatusName" placeholder="请选择"
                  @change="changeJob(changeForm.jobStatusName)">
                  <el-option v-for="item in zhuangtaiList1" :key="item.itemNo" :label="item.showName"
                      :value="item.showName">
                  </el-option>
              </el-select>
          </el-form-item>
          <br>
          <!-- 1：排队中 2：已叫号 3：已过号 4：已失效 5：已进仓 6：进仓过磅完成 7：出仓过磅完成 8：出仓过副磅完成 9：已出仓  10:已作废-->
          <div v-if="this.changeForm.jobStatusName == '已进仓'">
              <!-- 原始状态：排队中、已叫号、已过号   变更后状态：已进仓，更新进仓时间 -->
              <el-form-item label="进仓时间:" prop="mobilizationTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.mobilizationTime" ref="menuTree" placeholder="选择时间" style="width:190px">
                  </el-date-picker>
              </el-form-item>
          </div>
          <div v-else-if="this.changeForm.jobStatusName == '进仓过磅完成'">
              <!-- 原始状态：已进仓   变更后状态：进仓过磅完成-修改业务状态、进仓时间、进仓过磅重量(吨)、进仓过磅时间 -->
              <el-form-item label="进仓时间:" prop="mobilizationTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.mobilizationTime" ref="menuTree" placeholder="选择时间" style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="进仓过磅时间:" prop="entryWeighingTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.entryWeighingTime" ref="menuTree" placeholder="选择时间"
                      style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="进仓过磅重量:" class="jiage" prop="entryWeighing">
                  <el-input placeholder="请输入进仓过磅重量" v-number-input.float="3" v-model="changeForm.entryWeighing"
                      style="width: 190px"></el-input> <span class="danwei">吨</span>
              </el-form-item>
          </div>
          <div v-else-if="this.changeForm.jobStatusName == '出仓过磅完成'">
              <!--原始状态：已进仓、进仓过磅完成   变更后状态：出仓过磅完成
修改业务状态、进仓时间、进仓过磅重量(吨)、进仓过磅时间、出仓过磅重量(吨)、出仓过磅时间 -->
              <el-form-item label="进仓时间:" prop="mobilizationTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.mobilizationTime" ref="menuTree" placeholder="选择时间" style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="进仓过磅时间:" prop="entryWeighingTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.entryWeighingTime" ref="menuTree" placeholder="选择时间"
                      style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="进仓过磅重量:" prop="entryWeighing" class="jiage">
                  <el-input placeholder="请输入进仓过磅重量" v-number-input.float="3" v-model="changeForm.entryWeighing"
                      style="width: 190px"></el-input>
                      <span class="danwei">吨</span>
              </el-form-item>
              <el-form-item label="出仓过磅时间:" prop="exitMainTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.exitMainTime" ref="menuTree" placeholder="选择时间" style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="出仓过磅重量:" class="jiage" prop="exitMainWeighing">
                  <el-input placeholder="请输入出仓过磅重量" v-number-input.float="3"
                      v-model="changeForm.exitMainWeighing" style="width: 190px"></el-input><span class="danwei">吨</span>
              </el-form-item>
          </div>
          <!--原始状态：已进仓、进仓过磅完成、出仓过磅完成   变更后状态：出仓过副磅完成
修改业务状态、进仓时间、进仓过磅重量(吨)、进仓过磅时间、出仓过磅重量(吨)、出仓过磅时间、出仓过副磅重量（吨）、出仓过副磅时间 -->
          <!-- <div v-else-if="this.changeForm.jobStatusName == '出仓过副磅完成'">
              <el-form-item label="进仓时间:" prop="mobilizationTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.mobilizationTime" ref="menuTree" placeholder="选择时间" style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="进仓过磅时间:" prop="entryWeighingTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.entryWeighingTime" ref="menuTree" placeholder="选择时间"
                      style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="进仓过磅重量:" class="jiage" prop="entryWeighing">
                  <el-input placeholder="请输入进仓过磅重量" v-number-input.float="3" v-model="changeForm.entryWeighing"
                      style="width: 190px"></el-input><span class="danwei">吨</span>
              </el-form-item>
              <el-form-item label="出仓过磅时间:" prop="exitMainTime">
                  <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="changeForm.exitMainTime" ref="menuTree" placeholder="选择时间" style="width:190px">
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="出仓过磅重量:" class="jiage" prop="exitMainWeighing">
                  <el-input placeholder="请输入出仓过磅重量" v-number-input.float="3"
                      v-model="changeForm.exitMainWeighing" style="width: 190px"></el-input><span class="danwei">吨</span>
              </el-form-item>
          </div> -->
          <div v-else-if="this.changeForm.jobStatusName == '已出仓'">
              <!--原始状态：已进仓、进仓过磅完成、出仓过磅完成、出仓过副磅完成   变更后状态：已出仓
修改业务状态、进仓时间、进仓过磅重量(吨)、进仓过磅时间、出仓过磅重量(吨)、出仓过磅时间、出仓过副磅重量（吨）、出仓过副磅时间、出仓时间 -->
            <el-form-item label="进仓时间:" prop="mobilizationTime">
              <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="changeForm.mobilizationTime" ref="menuTree" placeholder="选择时间" style="width:190px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="进仓过磅时间:" prop="entryWeighingTime">
              <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss"  v-model="changeForm.entryWeighingTime" ref="menuTree" placeholder="选择时间"
                style="width:190px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="进仓过磅重量:" class="jiage" prop="entryWeighing">
              <el-input placeholder="请输入进仓过磅重量" v-number-input.float="3" v-model="changeForm.entryWeighing" style="width: 190px"></el-input><span class="danwei">吨</span>
            </el-form-item>
            <el-form-item label="出仓过磅时间:" prop="exitMainTime">
              <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss" v-model="changeForm.exitMainTime" ref="menuTree" placeholder="选择时间" style="width:190px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="出仓过磅重量:" class="jiage" prop="exitMainWeighing">
              <el-input placeholder="请输入出仓过磅重量" v-number-input.float="3"
                v-model="changeForm.exitMainWeighing" style="width: 190px"></el-input><span class="danwei">吨</span>
            </el-form-item>
            <!-- <el-form-item label="出仓过副磅时间:" prop="exitCompositeTime">
              <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss" v-model="changeForm.exitCompositeTime" ref="menuTree" placeholder="选择时间"
                style="width:190px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="出仓过副磅重量:" class="jiage" prop="exitCompositeWeighing">
              <el-input placeholder="请输入出仓过副磅重量" v-number-input.float="3"
                v-model="changeForm.exitCompositeWeighing" style="width: 190px"></el-input><span class="danwei">吨</span>
            </el-form-item> -->
            <el-form-item label="出仓时间:" prop="exFactoryTime">
              <el-date-picker type="datetime" format='yyyy-MM-dd HH:mm:ss' value-format="yyyy-MM-dd HH:mm:ss" v-model="changeForm.exFactoryTime" ref="menuTree" placeholder="选择时间" style="width:190px">
                </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeMark = false">取 消</el-button>
        <el-button @click="changeOK" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增入库计划 -->
    <ruku-plan-dialog v-if="xzVisible" :xzVisible.sync="xzVisible" :title="xzTitle" :xztableData="xztableData" :RKData.sync='RKData' :isShowDYFlag="2" :vhcNo="vhcNo"
    :ljjcId="ljjcId" :rowData="rowData"></ruku-plan-dialog>
    <!-- 新增出库计划 -->
    <chuKu-plan-dialog v-if="addPlanBillVisible" :addPlanBillVisible.sync="addPlanBillVisible" :title="ckTitle" :xztableData="xztableDataCK" :RKData.sync='RKDataCK' :isShowDYFlag="2" :mobilePhone="mobilePhone" :vhcNo="vhcNo" :ljjcId="ljjcId" :rowData="rowData"></chuKu-plan-dialog>
    <el-dialog title="查看图片" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="lookImgFlag" append-to-body width="800px" center>
      <div style="text-align: right;">
        <div id="printMe"  ref="print">
          <el-image style="width: 100%;" :src="imgUrl" fit="contain"></el-image>
        </div>
      </div>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="修改" class="register" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="editMark"  center width="500px">
      <el-form :rules="rules1" :model="addForm" :inline="true" ref="addForm" class="demo-form-inline" label-width="150px" size="mini" >
        <div class="">
          <el-form-item label="装货地净重:" class="jiage" prop="originalTon" v-if="addForm.isxiehuo">
            <el-input placeholder="请输入装货地净重" v-number-input.float="3"
              v-model="addForm.originalTon" style="width: 190px"></el-input><span class="danwei">吨</span>
          </el-form-item>
          <el-form-item label="装货地毛重:" class="jiage" prop="grossWeight" v-if="addForm.isxiehuo">
            <el-input placeholder="请输入装货地毛重" v-number-input.float="3"
              v-model="addForm.grossWeight" style="width: 190px"></el-input><span class="danwei">吨</span>
          </el-form-item>
          <el-form-item label="装货地皮重:" class="jiage" prop="tareWeight" v-if="addForm.isxiehuo">
            <el-input placeholder="请输入装货地皮重" v-number-input.float="3"
              v-model="addForm.tareWeight" style="width: 190px"></el-input><span class="danwei">吨</span>
          </el-form-item>
          <el-form-item label="发货单位:" prop="deliveryCompanyName">
            <div v-if="addForm.warehouseName">{{ addForm.deliveryCompanyName }}</div>
            <el-select v-model="addForm.deliveryCompanyName" v-else  placeholder="请选择发货单位名称" filterable clearable @change="fhChange">
              <el-option v-for="(item, index) in sfhList" :key="index" :label="item.deliveryCompanyName+'-'+item.receiveCompanyName"
                :value="item.deliveryCompanyName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货单位:" prop="receiveCompanyName">
            <div>{{addForm.receiveCompanyName}}</div>
          </el-form-item>
          <el-form-item label="随车榜单:" >
            <uploadImgs3 :imgList.sync='arrImg'  v-if="editMark" :max=1 ></uploadImgs3>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="saveFn" >保 存</el-button>
        <el-button @click="editMark=false" size="mini">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import RukuPlanDialog from '@/views/lj/manage/addRuKuPlan.vue'
import chuKuPlanDialog from '@/views/lj/manage/addChuKuPlan.vue'
import uploadImgs3 from '@/components/uploadImgs3.vue'
import {
  // 列表查询
  cVhcNoColour // 车辆颜色
} from '@/api/consignment'
import { getSchedulingAssignmentList, updateSchedulingAssignment, deleteSchedulingAssignment, detail, getQueueSettingsList, getJobStatusList,
  searchPhoneNumber, register, findFlieUrl, findFlieUnloadUrl, findCfOrderPc, updateSa } from '@/api/lj'
import {
  getRelationCustomer
} from '@/api/wms-stock'
export default {
  components: { RukuPlanDialog, chuKuPlanDialog, uploadImgs3 },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 20
      },
      total: 0,
      changeForm: {},
      changeRow: {},
      duilieList: [],
      zhuangtaiList: [],
      zhuangtaiList1: [],
      btnFlg: [],
      btnIdArr: ['01K00A0100', '01K00A0200', '01K00A0300', '01K00A0400', '01K00A0500'],
      rules: {
        entryWeighing: [{ required: true, message: '请输入进仓过磅重量', trigger: ['blur', 'change'] }],
        exitMainWeighing: [{ required: true, message: '请输入出仓过磅重量', trigger: ['blur', 'change'] }],
        exitCompositeWeighing: [{ required: true, message: '请输入出仓过副磅重量', trigger: ['blur', 'change'] }],
        queueId: [{ required: true, message: '请选择队列', trigger: ['blur', 'change'] }],
        jobStatusName: [{ required: true, message: '请选择状态', trigger: ['blur', 'change'] }],
        mobilizationTime: [{ required: true, message: '请选择进仓时间', trigger: ['blur', 'change'] }],
        entryWeighingTime: [{ required: true, message: '请选择进仓过磅时间', trigger: ['blur', 'change'] }],
        exitMainTime: [{ required: true, message: '请选择出仓过磅时间', trigger: ['blur', 'change'] }],
        exitCompositeTime: [{ required: true, message: '请选择出仓过副磅时间', trigger: ['blur', 'change'] }],
        exFactoryTime: [{ required: true, message: '请选择出仓时间', trigger: ['blur', 'change'] }]
      },
      createRegisterFormRules: {
        vehicleNo: [
          { required: true, message: '请输入车牌号', trigger: ['blur', 'change'] },
          { pattern: /[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Z]{1}[A-Z0-9]{5,6}/g, message: '请输入正确的车牌号' }
        ],
        mobilePhone: [{ required: true, message: '请输入手机号', trigger: ['blur', 'change'] }]
      },
      createRegisterForm: { jobType: 0 },
      changeMark: false,
      createRegisterDialog: false,
      createRegisterLoading: false,
      createRegisterMobilePhoneOptons: [],
      xzVisible: false,
      xzTitle: '',
      RKData: [],
      xztableData: [],
      xztableDataCK: [],
      RKDataCK: [],
      vhcNo: '',
      addPlanBillVisible: false,
      ckTitle: '',
      mobilePhone: '',
      ljjcId: '',
      lookImgFlag: false,
      imgUrl: '',
      statusTimer: null,
      rowData: {},
      rules1: {
        originalTon: [{ required: true, message: '请输入装货地净重', trigger: ['blur', 'change'] }],
        grossWeight: [{ required: true, message: '请输入装货地毛重', trigger: ['blur', 'change'] }],
        tareWeight: [{ required: true, message: '装货地皮重', trigger: ['blur', 'change'] }],
        deliveryCompanyName: [{ required: true, message: '请选择发货单位', trigger: ['blur', 'change'] }],
        receiveCompanyName: [{ required: true, message: '请选择收货单位', trigger: ['blur', 'change'] }]
      },
      editMark: false,
      addForm: {},
      arrImg: [],
      sfhList: []// 收发货地址
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/entryRegistration')

    this.value1 = this.getNowTime()
    this.getTimeFn()
    this.getList(this.searchFrom)
    this.startStatusTimer()
    getQueueSettingsList(this.searchFrom).then(res => {
      this.duilieList = res
    }).catch(err => {
      DonMessage.error(err.message)
    })
    getJobStatusList(this.searchFrom).then(res => {
      this.zhuangtaiList = res
      this.zhuangtaiList1 = res
    }).catch(err => {
      DonMessage.error(err.message)
    })
    this.getRelationCustomerS()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
    // 监听页面可见性变化
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy () {
    this.clearStatusTimer()
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    // 修改
    editFn (row) {
      this.addForm = {}
      this.$set(this.addForm, 'id', row.id)
      this.$set(this.addForm, 'isxiehuo', row.jobType == '卸货')
      this.$set(this.addForm, 'originalTon', row.originalTon)
      this.$set(this.addForm, 'grossWeight', row.grossWeight)
      this.$set(this.addForm, 'tareWeight', row.tareWeight)
      this.$set(this.addForm, 'deliveryCompanyName', row.deliveryCompanyName)
      this.$set(this.addForm, 'receiveCompanyName', row.receiveCompanyName)
      this.$set(this.addForm, 'orderId', row.orderId)
      this.$set(this.addForm, 'planOrderId', row.planOrderId)
      this.$set(this.addForm, 'warehouseName', row.warehouseName)

      findCfOrderPc({ status: row.jobType == '装货' ? 1 : 2 }).then(res => {
        this.sfhList = res.orderList
      }).catch(err => {
        DonMessage.error(err.message)
      })
      findFlieUrl({
        id: row.id
      }).then(res => {
        this.$set(this.arrImg, 0, { status: 'ready', url: res, id: row.id })
        this.editMark = true
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    fhChange (e) {
      let json = this.sfhList.find(item => item.deliveryCompanyName == e)
      console.log(json)
      if (json) {
        this.$set(this.addForm, 'orderId', json.orderId)
        this.$set(this.addForm, 'planOrderId', json.id)
        this.$set(this.addForm, 'receiveCompanyName', json.receiveCompanyName)
      }
    },
    // shChange (e) {
    //   let json = this.sfhList.find(item => item.receiveCompanyName == e)
    //   console.log(json)
    //   if (json) {
    //     this.$set(this.addForm, 'orderId', json.orderId)
    //     this.$set(this.addForm, 'planOrderId', json.id)
    //     this.$set(this.addForm, 'deliveryCompanyName', json.deliveryCompanyName)
    //   }
    // },
    saveFn () {
      if (this.arrImg.length == 0) {
        DonMessage.error('请选择需要上传的图片!')
        return
      }
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          if (!this.arrImg[0].id) {
            imgfile.append('file', this.arrImg[0].raw)
          }
          imgfile.append('params', JSON.stringify(this.addForm))
          const loading2 = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateSa(imgfile)
            .then(
              (res) => {
                this.getList()
                this.editMark = false
                DonMessage.success('成功')
                loading2.close()
              }
            )
            .catch((err) => {
              loading2.close()
              DonMessage.error(err.message)
            })
        } else {
        }
      })
    },
    handleVisibilityChange () {
      this.pageVisible = !document.hidden
      if (this.pageVisible) {
        this.startStatusTimer()
      } else {
        this.clearStatusTimer()
      }
    },
    // 启动状态轮询定时器
    startStatusTimer () {
      this.clearStatusTimer() // 先清除可能存在的定时器
      this.statusTimer = setInterval(() => {
        console.log('定时轮询获取状态')
        this.getList()
      }, 20000) // 20秒
    },
    // 清除状态轮询定时器
    clearStatusTimer () {
      if (this.statusTimer) {
        clearInterval(this.statusTimer)
        this.statusTimer = null
      }
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    changeOK () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          const loading2 = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.$set(this.changeForm, 'exitCompositeTime', this.changeForm.exitMainTime)
          this.$set(this.changeForm, 'exitCompositeWeighing', this.changeForm.exitMainWeighing)
          updateSchedulingAssignment(this.changeForm)
            .then(
              (res) => {
                this.getList()

                this.changeMark = false
                DonMessage.success('成功')
                loading2.close()
              }
            )
            .catch((err) => {
              loading2.close()
              DonMessage.error(err.message)
            })
        } else {
        }
      })
    },
    changeJob (valueS) {
      let that = this
      that.changeForm.jobStatus = that.zhuangtaiList1.filter((item) => item.showName === valueS)[0].itemNo
      // <!-- 1：排队中 2：已叫号 3：已过号 4：已失效 5：已进仓 6：进仓过磅完成 7：出仓过磅完成 8：出仓过副磅完成 9：已出仓  10:已作废-->
      detail({ id: that.changeForm.id })
        .then(
          (res) => {
            // that.changeForm = {}
            that.$set(that.changeForm, 'entryWeighing', res.entryWeighing)
            that.$set(that.changeForm, 'exitMainWeighing', res.exitMainWeighing)
            that.$set(that.changeForm, 'exitCompositeWeighing', res.exitCompositeWeighing)

            // that.changeForm = res
            if (res.mobilizationTime) {
              that.$set(that.changeForm, 'mobilizationTime', that.timestampToTime(res.mobilizationTime))
            }
            if (res.entryWeighingTime) {
              that.$set(that.changeForm, 'entryWeighingTime', that.timestampToTime(res.entryWeighingTime))
            }
            if (res.exitMainTime) {
              that.$set(that.changeForm, 'exitMainTime', that.timestampToTime(res.exitMainTime))
            }
            if (res.exitCompositeTime) {
              that.$set(that.changeForm, 'exitCompositeTime', that.timestampToTime(res.exitCompositeTime))
            }
            if (res.exFactoryTime) {
              that.$set(that.changeForm, 'exFactoryTime', that.timestampToTime(res.exFactoryTime))
            }

            that.$nextTick(() => {
              that.$refs['changeForm'].clearValidate()
            })
          }
        )
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    change (row) {
      let that = this
      that.changeForm.id = row.id
      that.zhuangtaiList1 = []
      if (row.jobStatusName == '排队中' || row.jobStatusName == '已过号' || row.jobStatusName == '已叫号') { // 已过号
        that.zhuangtaiList1.push(
          { itemNo: '5', showName: '已进仓' },
          { itemNo: '10', showName: '已作废' }
        )
      }
      if (row.jobStatusName == '已进仓') { // 已进仓
        that.zhuangtaiList1.push({ itemNo: '6', showName: '进仓过磅完成' },
          { itemNo: '7', showName: '出仓过磅完成' },
          // { itemNo: '8', showName: '出仓过副磅完成' },
          { itemNo: '9', showName: '已出仓' },
          { itemNo: '10', showName: '已作废' }
        )
      }
      if (row.jobStatusName == '进仓过磅完成') { // 进仓过磅完成
        that.zhuangtaiList1.push({ itemNo: '7', showName: '出仓过磅完成' },
          // { itemNo: '8', showName: '出仓过副磅完成' },
          { itemNo: '9', showName: '已出仓' },
          { itemNo: '10', showName: '已作废' }
        )
      }
      if (row.jobStatusName == '出仓过磅完成') { // 出仓过磅完成
        that.zhuangtaiList1.push(
          // { itemNo: '8', showName: '出仓过副磅完成' },
          { itemNo: '9', showName: '已出仓' },
          { itemNo: '10', showName: '已作废' }
        )
      }
      // if (row.jobStatusName == '出仓过副磅完成') { // 出仓过副磅完成
      //   that.zhuangtaiList1.push(
      //     { itemNo: '9', showName: '已出仓' },
      //     { itemNo: '10', showName: '已作废' }
      //   )
      // }
      if (row.jobStatusName == '已出仓') { // 已出仓
        that.zhuangtaiList1.push(
          { itemNo: '10', showName: '已作废' }
        )
      }
      that.changeMark = true

      that.$nextTick(() => {
        that.$refs['changeForm'].clearValidate()
      })
    },
    /**
     * 设置默认时间
     */
    getTimeFn () {
      const that = this
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)

      that.$set(that.searchFrom, 'createTime', [that.formatDate(start), that.formatDate(end)])
    },
    // 格式化时间
    formatDate (date) {
      var myyear = date.getFullYear()
      var mymonth = date.getMonth() + 1
      var myweekday = date.getDate()

      if (mymonth < 10) {
        mymonth = '0' + mymonth
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday
      }
      return myyear + '-' + mymonth + '-' + myweekday
    },

    /**
         * 格式化时间
         */
    timestampToTime (timestamp) {
      // 时间戳为10位需*1000，时间戳为13位不需乘1000
      var date = new Date(timestamp)
      var Y = date.getFullYear() + '-'
      var M =
                (date.getMonth() + 1 < 10
                  ? '0' + (date.getMonth() + 1)
                  : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s = date.getSeconds()
      return Y + M + D + h + m + s
    },

    shanchu (row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          deleteSchedulingAssignment({
            id: row.id
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.getList(this.searchFrom)
              loading.close()
            })
            .catch((err) => {
              loading.close()

              DonMessage.error(err.message)
            })
        })
        .catch(() => { })
    },
    // 初始默认执行(重点)
    getNowTime () {
      const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
        .toISOString()
        .split('T')[0] // 默认开始时间7天前
      const end = new Date(new Date().getTime())
        .toISOString()
        .split('T')[0]// 默认结束时间1天前
      console.log([start, end])
      return [start, end]
    },
    // 审核
    passClick (row) {
      this.addFrom = { ...row }
      this.drawerFlag = true
    },
    successFn () {
      this.getList()
    },
    destroy () {
      this.drawerFlag = false
    },

    // 查选
    chaxun () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })

      if (this.searchFrom.createTime) {
        this.searchFrom.registrationTimeStart = this.searchFrom.createTime[0]
        this.searchFrom.registrationTimeEnd = this.searchFrom.createTime[1]
      } else {
        this.searchFrom.registrationTimeStart = null
        this.searchFrom.registrationTimeEnd = null
      }
      if (this.searchFrom.jobStatArr) {
        this.$set(this.searchFrom, 'jobStatus', this.searchFrom.jobStatArr.toString())
      } else {
        this.$set(this.searchFrom, 'jobStatus', '')
      }
      getSchedulingAssignmentList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        loading.close()
      }).catch(err => {
        loading.close()

        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 20,
        createTime: null,
        createTimeStart: null,
        createTimeEnd: null
      }
      this.getTimeFn()

      this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    createRegisterCloseDialog () {
      console.log('createRegisterCloseDialog')
      this.createRegisterDialog = false
      this.createRegisterForm = {}
      this.$nextTick(() => {
        this.$refs['createRegisterForm'].clearValidate()
      })
    },
    createDialog () {
      this.changeMark = false
      this.changeForm = {}
      this.$nextTick(() => {
        this.$refs['changeForm'].clearValidate()
      })
    },
    createRegisterOpenedDialog () {
      console.log('createRegisterOpenedDialog')
    },
    createRegisterSubmit () {
      this.$refs['createRegisterForm'].validate((valid) => {
        if (valid) {
          const form = {
            driverId: this.createRegisterForm.driverId,
            queueId: this.createRegisterForm.queueId,
            vehicleNo: this.createRegisterForm.vehicleNo
          }
          const loading2 = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          register(form)
            .then(
              (res) => {
                console.log('res1', res)
                DonMessage.success('成功')
                loading2.close()
                this.createRegisterCloseDialog()

                this.getList(this.searchFrom)
              },
              (res) => {
                DonMessage.error(res.message)
                console.log('res2', res)
                loading2.close()
              }
            )
            .catch((err) => {
              console.log('catch err', err)
              loading2.close()
              DonMessage.error(err.message)
            })
          console.log('valid', form)
        } else {
          console.log('invalid', this.createRegisterForm)
        }
      })
    },

    createRegisterUpperVehicleNo () {
      // const abc = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
      // const r = this.createRegisterForm.vehicleNo.split("").map((v) => {
      //     if (abc.indexOf(v) >= 0) {
      //         return v.toUpperCase();
      //     } else {
      //         return v;
      //     }
      // });
      // this.createRegisterForm.vehicleNo = r.join("");
    },
    createRegisterSelect (v) {
      this.createRegisterForm.driverId = v
      console.log('createRegisterSelect', v)
    },
    createRegisterRemoteMethod (query) {
      console.log('query', query)
      if (query !== '') {
        this.createRegisterLoading = true
        searchPhoneNumber({ account: query }).then(
          (data) => {
            console.log('res:', data)
            this.createRegisterMobilePhoneOptons = data.map((v) => {
              return { value: v.id, label: v.account }
            })
            this.createRegisterLoading = false
          },
          (error) => {
            console.log('fail:', error)
            DonMessage.error(error.message)
            this.createRegisterLoading = false
          }
        )
      }
    },
    addPlan (row) {
      if (row.jobType == '装货') {
        this.addPlanBillVisible = true
        this.ckTitle = '新增出库计划'
        this.mobilePhone = row.mobilePhone
      } else {
        this.xzVisible = true
        this.xzTitle = '新增入库计划'
      }
      this.vhcNo = row.vehicleNo
      this.ljjcId = row.id
      this.rowData = row
    },
    lookImg (row, flag) {
      this.lookImgFlag = true
      if (flag == 1) {
        this.findFlieUrl(row.id)
      } else {
        this.findFlieUnloadUrl(row.id)
      }
    },
    findFlieUrl (id) {
      findFlieUrl({
        id: id
      }).then(res => {
        this.imgUrl = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    findFlieUnloadUrl (id) {
      findFlieUnloadUrl({
        id: id
      }).then(res => {
        this.imgUrl = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor {
  width: 350px !important;
}
.register {
    .el-form-item--mini.el-form-item,
    .el-form-item--small.el-form-item {
        margin-bottom: 18px;
    }
    ::v-deep .el-dialog__body {
        text-align: initial;
        padding: 25px 25px 30px;
    }
    ::v-deep .el-dialog__header {
        padding: 8px 20px !important;
        background-color: #0c46a2;
        .el-dialog__title {
            color: #fff;
        }
        .el-dialog__headerbtn {
            top: 12px;
            .el-dialog__close {
                color: #fff;
            }
        }
    }
    ::v-deep .el-input__inner,
    ::v-deep .el-textarea__inner {
        width: 190px !important;
    }
    ::v-deep .el-textarea__inner {
        height: 100px;
        margin-bottom: 0 !important;
    }
    .el-dialog__footer {
        .el-button {
            padding: 8px 18px !important;
        }
    }
}
</style>
